export default __webpack_public_path__ + "static/media/ic-alert-modal.e5840750.svg";